import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import sv from "./locales/sv.json";

// v2.0.11 — 4 langues supportées (choix user 1b/2a)
// Détection : localStorage > cookie > navigator.language > fallback FR
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      de: { translation: de },
      sv: { translation: sv },
    },
    fallbackLng: "fr",
    // Phase 81 — les langues sont administrables : plus de liste figée, « en-US » → « en »
    supportedLngs: false,
    load: "languageOnly",
    detection: {
      order: ["localStorage", "cookie", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "pag_language",
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
